module.exports = __webpack_public_path__ + "static/media/image_terapia_t_1.fb4a14f8.png";